import { render, staticRenderFns } from "./ReturnStatus.vue?vue&type=template&id=fbe6c372&"
import script from "./ReturnStatus.vue?vue&type=script&lang=js&"
export * from "./ReturnStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReturnStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbe6c372')) {
      api.createRecord('fbe6c372', component.options)
    } else {
      api.reload('fbe6c372', component.options)
    }
    module.hot.accept("./ReturnStatus.vue?vue&type=template&id=fbe6c372&", function () {
      api.rerender('fbe6c372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnStatus.vue"
export default component.exports